import { apiRequest } from '@/shared/api';
import type { ConversationSettings, ConversationSettingsUpdate, CurrentUser } from '../model/types';

/** Авторизация — по заголовку с Telegram initData, его подставляет transport. */
/** `quiet` — фоновое обновление: сбой сети не в отчёт (см. `RequestOptions.quiet`). */
export function getCurrentUser(signal?: AbortSignal, quiet?: boolean): Promise<CurrentUser> {
  return apiRequest<CurrentUser>('/me', { signal, quiet });
}

export function getConversationSettings(signal?: AbortSignal): Promise<ConversationSettings> {
  return apiRequest<ConversationSettings>('/me/settings', { signal });
}

/** Изменение вступает в силу со следующей же реплики — сервер ничего не кеширует (см. `loadStoredProfile`). */
export function updateConversationSettings(changes: ConversationSettingsUpdate): Promise<void> {
  return apiRequest<void>('/me/settings', { method: 'PATCH', body: changes });
}
